import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const BASE_URL = process.env.API_URL + '/admin'

const CategoryService = {
  actions: {
    fetchAllSellSheetCategories ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/sell-sheet-categories',
          method: 'GET'
        })
          .then(resp => {
            const categories = resp.data.categories
            commit('api_success')
            resolve(resp)
            return categories
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchSellSheetCategoriesCount ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/sell-sheet-categories/count',
          method: 'GET'
        })
          .then(resp => {
            const count = resp.data.count
            commit('api_success')
            resolve(resp)
            return count
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    createSellSheetCategory ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/sell-sheet-category',
          data: data,
          method: 'POST',
          headers: {'Content-Type': 'multipart/form-data; boundary=---------------------------974767299852498929531610575'}
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    deleteSellSheetCategory ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/sell-sheet-category/' + id,
          method: 'delete'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    editSellSheetCategory ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/sell-sheet-category/' + data.get('id'),
          data: data,
          method: 'POST'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    }
  }
}

export default CategoryService



// WEBPACK FOOTER //
// ./src/store/modules/sellsheetCategory.module.js